import React from 'react';
import { AuditTab } from 'areas/shared/components';

class AuditInfo extends React.Component {

    render() {
        let opts = {
            entityType: "CERTIFICATION",
            tabKey: this.props.tabKey,
            active: this.props.active,
            helpKey: this.props.helpKey,
            selectedId: this.props.selectedId,
            encryptedKey: true,
            title: ''
        };

        return (
            <React.Fragment>
                <AuditTab {...opts} />
            </React.Fragment>
        );
    }
}

export default AuditInfo;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/auditInfo/AuditInfo.js